<template>
    <section class="container">
        <div class="row">
            <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                <adminSidenav></adminSidenav>
            </div>
            <div class="col">
                <div class="container">
                    <div>
                        <h2>공지사항</h2>
                    <div class="text-right">
                        <p v-if="$auth.check() && !!$auth.user().roleNames.includes('ADMIN')">
                        <button class="btn btn-primary" v-on:click="moveWrite()">글쓰기</button>
                    </p></div>
                    </div>
                    <table class="table">
                        <thead>
                       <tr>
                            <th class="text-center">제목</th>
                            <th class="text-center">등록일</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="noticeList.length == 0">
                            <th colspan="100%" class="text-center"> 공지사항이 등록되지 않았습니다.</th>
                        </tr>
                        <tr v-else v-for="(notice,idx) in noticeList">
                            <td><router-link :to="{name : 'noticeShow', params : { id : notice.id }}">{{notice.title}}</router-link></td>
                            <td class="text-center">{{notice.modifiedDate}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <button type="button" class="btn-white btn btn-block" v-on:click="nextPage()" v-if="currentLength != 0 && currentLength > 10">더보기</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import adminSidenav from '@/components/admin/Sidenav.vue'

    export default {
        name: 'NoticeList',
        components: { adminSidenav },
        data() {
            return {
                noticeList: [],
                page:{
                    pageNum:0,
                    pageSize:4
                },
                currentLength : 0
            }
        },
        methods: {
            nextPage() {
                    this.page.pageNum += 1;
                    this.getList();
            },
            getList() {
                let me = this;

                this.axios.get(process.env.VUE_APP_NOTICE_API_URL + `/list?page=${this.page.pageNum}&size=${this.page.pageSize}`)
                    .then(function (res) {
                        me.currentLength = res.data.length;
                        for (let i = 0 ; i < res.data.length ; i++) {
                            me.noticeList.push(res.data[i]);
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            moveWrite() {
                this.$router.push("noticeWrite");
            }
        },
        mounted() {
            this.getList();
        },
    }
</script>
<style scoped>
    .container h2{
    padding-bottom: 10px;
    }

</style>